import React from 'react';
import { Navigate } from 'react-router-dom';

interface User {
  role: string;
  [key: string]: any;
}

interface ProtectedRouteProps {
  isAuthenticated: boolean;
  user?: User | null;
  requiredRole?: 'admin' | 'moderator' | 'approved_user' | 'advanced_user';
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ isAuthenticated, user, requiredRole, children }) => {
  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && user) {
    // Simple role check - strictly equal or higher hierarchy not currently implemented for simplicity unless requested
    // Assuming 'admin' has access to everything for now
    if (requiredRole === 'admin' && user.role !== 'admin') {
      return <Navigate to="/" replace />;
    }
    if (requiredRole === 'moderator' && user.role !== 'admin' && user.role !== 'moderator') {
      return <Navigate to="/" replace />;
    }
    // Add other role checks if needed
  }

  return <>{children}</>;
};

export default ProtectedRoute;